import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './index.less';
import {
  Form, Select, Button, Spin, Input,
} from 'antd';
import { FormattedMessage } from 'react-intl';
import wrapReact from '../../../util/react';
import { actUI } from '../../../redux/action/ui';
import { msgCB } from '../../../util/fetch/msgFetch';
import { CB_STATUS } from '../../../util/fetch/cFetch';

const FormItem = Form.Item;
const { Option } = Select; // optional

export class NewForm extends Component {
  handleSubmit = (e) => {
    e.preventDefault();
    const {
      intl, form, onSubmit, dispatch,
    } = this.props;
    const { formatMessage } = intl;
    const cb = (res) => {
      actUI(dispatch, {
        uiAccount: {
          uiAddForm: { loading: false },
          uiTable: { loading: false },
        },
      });
      if (res.status === CB_STATUS.SUCCESS) {
        actUI(dispatch, {
          uiAccount: {
            uiEditForm: {
              data: {
                DisplayName: res.payload.DisplayName,
                AccountName: res.payload.AccountName,
                Password: res.payload.Password,
                Device_Type: res.payload.Device_Type,
                Device_Key: res.payload.Device_Key,
                AssociatedDevice: res.payload.AssociatedDevice,
                DeviceDisplayName: res.payload.DeviceDisplayName,
              },
            },
          },
        });
      }
      return msgCB(res.status, formatMessage);
    };
    form.validateFields((err, values) => {
      if (!err) {
        const t = {
          SerialNumber: values.associatedDevice,
          DisplayName: values.displayName,
        };
        actUI(dispatch, {
          uiAccount: {
            uiAddForm: { loading: true },
            uiTable: { loading: true },
          },
        });
        onSubmit(t, cb);
      }
    });
  }

  handleDropdown = () => {
    const { getDeviceType, dispatch } = this.props;

    actUI(dispatch, { uiAccount: { uiAddForm: { selectLoading: true } } });
    const cb = (res) => {
      if (res.status === CB_STATUS.SUCCESS) {
        actUI(dispatch, { uiAccount: { uiAddForm: { selectLoading: false } } });
      }
    };

    getDeviceType(cb);
  }

  getSelectDevices = () => {
    const { data } = this.props;
    return data.results.map(value => (
      <Option key={value.SerialNumber}>{value.DisplayName}</Option>
    ));
  }

  render() {
    const {
      intl, form, filePath, ui, onCancel,
    } = this.props;
    const { formatMessage } = intl;
    const { getFieldDecorator } = form;
    return (
      <Form
        layout="horizontal"
        onSubmit={this.handleSubmit}
        className={`${filePath}`}
      >
        <FormItem
          label={formatMessage({
            id: 'Account.displayName',
            defaultMessage: 'display name',
          })}
        >
          {getFieldDecorator('displayName', {
            rules: [
              {
                required: true,
                message: formatMessage({
                  id: 'Account.displayNameCheck',
                  defaultMessage: 'please input display name',
                }),
              },
              {
                max: 20,
                min: 2,
                message: formatMessage({
                  id: 'validator.accountInvalidLength',
                  defaultMessage: 'length of input is not ok',
                }),
              },
              {
                pattern: /^[A-Za-z0-9äöüÄÖÜß]+[A-Za-z0-9äöüÄÖÜß\s]+$/,
                message: formatMessage({
                  id: 'validator.noSpecialChar',
                  defaultMessage: 'only a-z, A-Z, 0-9 charaters are accepted',
                }),
              },
            ],
            initialValue: '',
          })(<Input autoComplete="off" />)}
        </FormItem>
        <FormItem
          label={formatMessage({
            id: 'Account.associatedDevice',
            defaultMessage: 'please choose associated device',
          })}
        >
          <Spin spinning={ui.selectLoading}>
            {getFieldDecorator('associatedDevice', {
              rules: [
                {
                  required: true,
                  message: formatMessage({
                    id: 'validator.empty',
                    defaultMessage: 'please select associated device',
                  }),
                },
              ],
            })(
              <Select
                className="select-name"
                onDropdownVisibleChange={this.handleDropdown}
                notFoundContent={formatMessage({
                  id: 'app.data.empty',
                  defaultMessage: 'no data',
                })}
                dropdownClassName="container_account_AddForm_select"
              >
                {this.getSelectDevices()}
              </Select>,
            )}
          </Spin>
        </FormItem>
        <FormItem className="btn-area">
          <Button type="primary" onClick={onCancel} className="form-bt">
            <FormattedMessage id="app.btn.cancel" defaultMessage="cancel" />
          </Button>
          <Button
            type="primary"
            htmlType="submit"
            loading={ui.loading}
            className="form-bt"
          >
            <FormattedMessage id="app.btn.ok" defaultMessage="ok" />
          </Button>
        </FormItem>
      </Form>
    );
  }
}

NewForm.propTypes = {
  data: PropTypes.shape({
    count: PropTypes.number.isRequired,
    results: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number.isRequired,
        SerialNumber: PropTypes.string.isRequired,
        DisplayName: PropTypes.string.isRequired,
      }).isRequired,
    ).isRequired,
  }).isRequired,
  ui: PropTypes.shape({
    loading: PropTypes.bool.isRequired,
    selectLoading: PropTypes.bool.isRequired,
  }).isRequired,
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  getDeviceType: PropTypes.func.isRequired,
  filePath: PropTypes.string.isRequired,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }).isRequired,
  form: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
};

export default Form.create()(wrapReact(NewForm, 'container_account_AddForm'));
